import React from 'react';
import { CardComponent } from '../CardComponent';

interface Period {
  period: string;
  checked: boolean;
  key: string;
}

interface Option {
  period: string;
}

interface EditPermissionProps {
  isLoading: boolean;
  permissionPeriods: Period[];
  periodPermissionsChange: (key: string, checked: boolean) => void;
  setDefaultPeriod: (period: string) => void;
  defaultPeriod: string;
  selectDefaultPeriod: Option[];
  hasNotesAccess: boolean;
  setHasNotesAccess: (hasAccess: boolean) => void;
  flagAbility: boolean;
  setFlagAbility: (flagAbility: boolean) => void;
  hasAccessToCustomDateRanges: boolean;
  setHasAccessToCustomDateRanges: (hasAccess: boolean) => void;
  hasApiAccess: boolean;
  setHasApiAccess: (hasAccess: boolean) => void;
  hasExportAccess: boolean;
  setHasExportAccess: (hasAccess: boolean) => void;
  savePermissions: () => void;
  closeEditPermissionsModal: () => void;
  bankName: string;
  hasMFAEnabled: boolean;
  setHasMFAEnabled: (enabled: boolean) => void;
  hasSelfServeAbility: boolean;
  setSelfServeAbility: (enabled: boolean) => void;
  hasSmartSummariesAccess: boolean;
  setHasSmartSummariesAccess: (hasAccess: boolean) => void;
}

export function EditPermission(props: EditPermissionProps) {
  const { isLoading, permissionPeriods, periodPermissionsChange, setDefaultPeriod,
    defaultPeriod, selectDefaultPeriod, hasNotesAccess, setHasNotesAccess,
    flagAbility, setFlagAbility, hasAccessToCustomDateRanges, setHasAccessToCustomDateRanges,
    hasApiAccess, setHasApiAccess, hasExportAccess, setHasExportAccess,
    savePermissions, closeEditPermissionsModal, bankName, hasMFAEnabled, setHasMFAEnabled,
    hasSelfServeAbility, setSelfServeAbility, hasSmartSummariesAccess, setHasSmartSummariesAccess,
  } = props;

  return (
    <CardComponent
      title={`Edit Permissions for ${bankName}`}
      titleStyles={{ display: 'inline-block', fontSize: '2.6rem', fontWeight: 400, marginLeft: '30px', marginTop: '20px' }}
      styles={{ position: 'fixed', top: '20%', left: '15%', zIndex: 1050, background: 'white', minHeight: '430px', width: '800px', border: 'solid grey', borderRadius: '10px' }}
      isLoading={isLoading}
      disableCardBackgroundColor
    >
      <div className='blacklight'
        style={{ marginLeft: '20px', marginRight: '20px' }}
      >
        <form>
          <div>
            <div className="row">
              <div className="col s12 m6" style={{ marginLeft: '20px' }}>
                <section>
                  <h5>Periods</h5>
                  <section
                    style={{ paddingLeft: '20px' }}
                  >
                    {permissionPeriods.map(({ period, checked, key }) => (
                      <div key={key}>
                        <label>
                          <input
                            id={key}
                            type="checkbox"
                            checked={checked}
                            onChange={() => { periodPermissionsChange(key, checked) }}
                          />
                          <span style={{ marginLeft: '10px' }}>
                            {period}
                          </span>
                        </label>

                      </div>
                    ))}
                  </section>
                </section>
              </div>
              <div className="col s12 m6" style={{ marginRight: '30px' }}>
                <section className="blacklight" style={{ marginLeft: '10px' }}>
                  <label>Default Period</label>
                  <select
                    className="custom-select"
                    onChange={(e) => { setDefaultPeriod(e.target.value) }}
                    value={defaultPeriod}
                  >
                    {selectDefaultPeriod.map((option, index) => (
                      <option
                        key={index}
                        value={option.period}
                      >
                        {option.period}
                      </option>
                    ))}
                  </select>
                </section>
                <section style={{ marginTop: '10px', marginLeft: '10px' }}>
                  <div>
                    <label>
                      <input type="checkbox"
                        checked={hasNotesAccess}
                        onChange={() => { setHasNotesAccess(!hasNotesAccess) }}
                      />
                      <span style={{ marginLeft: '10px' }}>
                        Client has notes indicator and notes filter.
                      </span>
                    </label>
                  </div>
                  <div>
                    <label>
                      <input type="checkbox"
                        checked={flagAbility}
                        onChange={() => { setFlagAbility(!flagAbility) }}
                      />
                      <span style={{ marginLeft: '10px' }}>
                        Give this the client the ability to flag and hide sensative comments.
                      </span>
                    </label>
                  </div>
                  {/* <div>                             
                    <label>
                      <input type="checkbox" 
                        
                      />
                      <span style={{marginLeft:'10px'}}>
                        Give this the client the ability to access social media pages.
                      </span>
                    </label>
                  </div> */}
                  <div>
                    <label>
                      <input type="checkbox"
                        checked={hasAccessToCustomDateRanges}
                        onChange={() => { setHasAccessToCustomDateRanges(!hasAccessToCustomDateRanges) }}
                      />
                      <span style={{ marginLeft: '10px' }}>
                        Give the client access to custom date ranges.
                      </span>
                    </label>
                  </div>
                  <div>
                    <label
                    >
                      <input type="checkbox"
                        checked={hasApiAccess}
                        onChange={() => { setHasApiAccess(!hasApiAccess) }}
                      />
                      <span style={{ marginLeft: '10px' }}>
                        Give the client access to API.
                      </span>
                    </label>
                  </div>
                  <div>
                    <label
                    >
                      <input type="checkbox"
                        checked={hasMFAEnabled}
                        onChange={() => { setHasMFAEnabled(!hasMFAEnabled) }}
                      />
                      <span style={{ marginLeft: '10px' }}>
                        Enable MFA.
                      </span>
                    </label>
                  </div>
                  <div>
                    <label>
                      <input type="checkbox"
                        checked={hasExportAccess}
                        onChange={() => { setHasExportAccess(!hasExportAccess) }}
                      />
                      <span style={{ marginLeft: '10px' }}>
                        Give the client access to data export.
                      </span>
                    </label>
                    <label
                    >
                      (Please make sure client has "All" Template).
                    </label>
                  </div>
                  <div>
                    <label>
                      <input type="checkbox"
                        checked={hasSelfServeAbility}
                        onChange={() => { setSelfServeAbility(!hasSelfServeAbility) }}
                      />
                      <span style={{ marginLeft: '10px' }}>
                        Give the client access to manage user’s ability to edit/move/delete survey results.
                      </span>
                    </label>
                  </div>
                  <div>
                    <label>
                      <input type="checkbox"
                        checked={hasSmartSummariesAccess}
                        onChange={() => { setHasSmartSummariesAccess(!hasSmartSummariesAccess) }}
                      />
                      <span style={{ marginLeft: '10px' }}>
                        Give the client access to manage user’s ability to access Smart Summaries Dashboard.
                      </span>
                    </label>
                  </div>
                </section>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            {isLoading ? "" :
              <div style={{ marginTop: '5px' }}>
                <a onClick={() => { savePermissions() }}
                  className="btn btn-action"
                  style={{ marginRight: '10px', color: 'white' }}
                >
                  Save
                </a>
                <a onClick={closeEditPermissionsModal}
                  className="btn btn-white"
                  style={{ marginRight: '10px' }}
                >
                  Cancel
                </a>
              </div>
            }
          </div>
        </form>
      </div>
    </CardComponent>
  );
}
